import { cn } from '@workspace/ui/lib/utils'
import type { RiskSeverity } from '../types'

const SEVERITY_STYLES: Record<RiskSeverity, string> = {
  critical: 'bg-red-500/10 text-red-400',
  high: 'bg-amber-500/10 text-amber-400',
  moderate: 'bg-blue-500/10 text-blue-400',
}

export function SeverityTag({ severity }: { severity: RiskSeverity }) {
  return (
    <span
      className={cn(
        'shrink-0 rounded-full px-1.5 py-0.5 text-[10px] font-medium capitalize',
        SEVERITY_STYLES[severity]
      )}
    >
      {severity}
    </span>
  )
}
